/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const e=require("./badge/Badge.js"),r=require("./badge/BadgeContainer.js"),o=require("./loader/Loader.js"),t=require("./skeleton/Skeleton.js");exports.Badge=e.Badge;exports.BadgeContainer=r.BadgeContainer;exports.Loader=o.Loader;exports.Skeleton=t.Skeleton;
